<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_deduction_item_add === true">บันทึกรายการหักเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <h2>ทำรายการสรุปยอด พนักงาน</h2>
    <div class="d-flex">
        <div class="mr-1 date_employee_summary_list">
            <v-select label="เลือกเดือน" v-model="month_select" :items="$store.state.monthList" item-text="name" item-value="id" color="primary" hide-details="auto" outlined>
            </v-select>
        </div>
        <div class="ml-1 searchdate_employee_summary_list">
            <v-btn color="#28ab28" class="white--text" @click="createSummaryEmployee()" width="100%" height="55">
                ตกลง
            </v-btn>
        </div>
    </div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false && month">
        <div class="d-flex justify-space-between mb-3">
            <h2>รายการ</h2>
            <h2>ยอดรวมทั้งหมด {{ currencyFormat(data.reduce((sum,number) => { return sum + ((number.salary + number.cal_ot) - number.minus_total) }, 0)) }} บาท</h2>
        </div>
        <v-card class="pa-3 mb-3" v-for="(detail,index) in data" :key="index">
            <div class="d-flex justify-space-between mb-3">
                <h3>ชื่อ-สกุล : {{ detail.nickname }}</h3>
                <h3>รวม {{ currencyFormat((detail.salary + detail.cal_ot) - detail.minus_total) }} บาท</h3>
            </div>
            <div class="grid_detail_employee_summary_list">
                <div>
                    <div>วันทำงานรวม : {{ detail.work_count }} วัน</div>
                    <div>OT รวม : {{ detail.ot }} ชั่วโมง</div>
                    <div>หักเงินรวม : {{ currencyFormat(detail.minus_total) }} บาท</div>
                </div>
                <div>
                    <div>เงินเดือน : {{ detail.salary }} บาท</div>
                    <div>มูลค่า OT รวม : {{ currencyFormat(detail.cal_ot) }} บาท</div>
                    <div>
                        <v-btn color="error" class="white--text" @click="openDeductMoney(detail.id)" width="50%" height="50">
                            รายการหักเงิน
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-card>
        <div>
            <v-btn width="100%" height="50" @click="summaryEmployee()">สรุปยอด</v-btn>
        </div>
        <v-dialog v-model="open_deduct_money" persistent max-width="600px">
            <div v-if="loading_detail_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_detail_page === false">
                <v-form ref="form_deduction_item" @submit.prevent="editDeductionItemEmployeeOrPartTime()">
                    <v-card-title class="justify-space-between">
                        <div>
                            รายการหักเงิน
                        </div>
                        <div class="cursor_employee_summary_list" @click="open_deduct_money = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <div class="text-right mb-3">
                                        <h2>
                                            ยอดรวมทั้งหมด {{ broken_item_price_all }} บาท
                                        </h2>
                                    </div>
                                    <div class="d-flex mb-3 pb-2 deduct_money_employee_summary_list">
                                        <div class="mr-1">รายการ</div>
                                        <div class="ml-1">ยอดหัก (บาท)</div>
                                    </div>
                                    <div class="d-flex mb-3 detail_deduct_money_employee_summary_list">
                                        <div class="mr-1">
                                            <v-text-field label="ประกันสังคมยอดหัก %" type="number" v-model="social_security" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกประกันสังคมยอดหัก %']" required outlined></v-text-field>
                                        </div>
                                        <div class="ml-1 mr-1 d-flex align-center">
                                            {{ currencyFormat((social_security * salary) / 100) }}
                                        </div>
                                        <div class="ml-1">

                                        </div>
                                    </div>

                                    <div class="d-flex mb-1 detail_deduct_money_employee_summary_list" v-for="(broken_item,index) in broken_item_list" :key="index">
                                        <div class="mr-1">
                                            <v-text-field label="รายการหัก" v-model="broken_item.name" hide-details="auto" outlined></v-text-field>
                                        </div>
                                        <div class="ml-1 mr-1">
                                            <v-text-field class="mb-1" label="ยอดหัก (บาท)" type="number" v-model="broken_item.price" hide-details="auto" outlined></v-text-field>
                                        </div>
                                        <div class="ml-1 d-flex justify-center align-center">
                                            <v-icon class="cursor_employee_summary_list" v-if="broken_item_list.length > 1" @click="deleteBrokenItemList(broken_item.id)" size="30">mdi-delete</v-icon>
                                        </div>

                                    </div>

                                    <div class="text-right">
                                        <v-btn color="primary" type="button" @click="addBrokenItemList()" hide-details="auto" class="white--text" height="50">
                                            เพิ่มรายการหัก
                                        </v-btn>
                                    </div>

                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                            บันทึกการทำรายการ
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="open_alert_show_add" persistent max-width="600">
            <v-card>
                <v-card-title>
                    สำเร็จ
                </v-card-title>

                <v-card-text>
                    ทำรายการสรุปยอดพนักงานเรียบร้อย
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text @click="confirmSuccess()">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <v-dialog v-model="open_alert_error" persistent max-width="600">
        <v-card>
            <v-card-title>
                คำเตือน
            </v-card-title>

            <v-card-text>
                เดือนนี้ทำรายการสรุปยอดพนักงานเรียบร้อยแล้ว
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text @click="open_alert_error = false">
                    ตกลง
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import summary from '@/api/team/teamreportsummary/summary.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            loading_detail_page: true,
            month_select: null,
            month: null,
            alert_show_deduction_item_add: false,
            open_alert_show_add: false,
            open_alert_error: false,
            open_deduct_money: false,
            data: [],
            deduct_money_id: null,
            social_security: '',
            salary: '',
            broken_item_list: [],
        }
    },
    methods: {
        currencyFormat,
        async createSummaryEmployee() {
            if (this.month_select) {
                this.loading_page = true
                this.month = null
                summary.createSummaryEmployee(1, this.month_select).then((response) => {
                    if (response.data.successful === true && response.data.workTimeList.length > 0) {
                        this.month = this.month_select
                        response.data.workTimeList.forEach(detail => {
                            this.data.push({
                                id: detail.id,
                                nickname: detail.nickname,
                                work_count: detail.work_count,
                                ot: detail.ot,
                                minus_total: 0,
                                salary: detail.salary,
                                cal_ot: detail.cal_ot,
                            })
                        })
                    }
                    if (response.data.successful === false) {
                        this.open_alert_error = true
                    }
                    this.loading_page = false
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async openDeductMoney(id) {
            this.deduct_money_id = id
            let deduct_money_list = this.data.find((detail) => {
                return detail.id == id
            })

            this.salary = deduct_money_list.salary
            this.loading_detail_page = true
            this.open_deduct_money = true
            this.broken_item_list = []
            summary.detailDeductionItemEmployeeOrPartTime(id).then((response) => {
                if (response.data.successful === true) {
                    response.data.conclusionWorkLists.forEach((detail, index) => {
                        if (detail.type_deduction == 0) {
                            this.broken_item_list.push({
                                id: index + 1,
                                name: detail.name,
                                price: detail.price,
                            })
                        }
                        if (detail.type_deduction == 1) {
                            this.social_security = detail.name
                        }
                    })
                    if (this.broken_item_list.length == 0) {
                        this.broken_item_list.push({
                            id: 1,
                            name: null,
                            price: '',
                        })
                    }
                    this.loading_detail_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async addBrokenItemList() {
            let lastId = this.broken_item_list[this.broken_item_list.length - 1]
            this.broken_item_list.push({
                id: lastId.id + 1,
                name: null,
                price: '',
            })
        },
        async deleteBrokenItemList(id) {
            this.broken_item_list = this.broken_item_list.filter((detail) => {
                return detail.id != id
            })
        },
        async editDeductionItemEmployeeOrPartTime() {
            if (this.$refs.form_deduction_item.validate()) {
                this.loading_detail_page = true
                let type_deduction = [1]
                let name = [this.social_security]
                let price = [(this.social_security * this.salary) / 100]

                this.broken_item_list.forEach(detail => {
                    if (detail.price !== '') {
                        type_deduction.push(0)
                        name.push(detail.name)
                        price.push(detail.price)
                    }
                })

                const data = {
                    type_deduction: type_deduction,
                    name: name,
                    price: price,
                }

                summary.editDeductionItemEmployeeOrPartTime(this.deduct_money_id, data).then((response) => {
                    if (response.data.successful === true) {
                        let data_detail = this.data.find((detail) => {
                            return detail.id == this.deduct_money_id
                        })
                        data_detail.minus_total = response.data.deduct
                        this.open_deduct_money = false
                        this.alert_show_deduction_item_add = true
                        setTimeout(() => this.alert_show_deduction_item_add = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async summaryEmployee() {
            this.loading_page = true
            let id = []
            let sum_deduct_money = []
            let salary = []
            let value_ot = []
            let total_slary = []

            this.data.forEach(detail => {
                id.push(detail.id)
                sum_deduct_money.push(currencyFormat(detail.minus_total))
                salary.push(detail.salary)
                value_ot.push(currencyFormat(detail.cal_ot))
                total_slary.push(currencyFormat((detail.salary + detail.cal_ot) - detail.minus_total))
            })
            const data = {
                id: id,
                sum_deduct_money: sum_deduct_money,
                salary: salary,
                value_ot: value_ot,
                total_slary: total_slary,
            }

            summary.summaryEmployee(data).then((response) => {
                if (response.data.successful === true) {
                    this.open_alert_show_add = true
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        },
        async confirmSuccess() {
            this.$router.push('/summary')
        },
    },
    computed: {
        broken_item_price_all() {
            let sum_all = 0
            if (this.salary !== '') {
                sum_all += parseInt(this.salary)
            }
            if (this.social_security !== '') {
                sum_all -= parseInt((this.social_security * this.salary) / 100)
            }
            this.broken_item_list.forEach((detail) => {
                if (detail.price !== '') {
                    sum_all -= parseInt(detail.price)
                }
            })

            return currencyFormat(sum_all)
        }

    }
}
</script>

<style scoped>
.date_employee_summary_list {
    width: 40%;
}

.searchdate_employee_summary_list {
    width: 20%;
}

.grid_detail_employee_summary_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-row-gap: 10px;
}

.cursor_employee_summary_list {
    cursor: pointer;
}

.deduct_money_employee_summary_list {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.deduct_money_employee_summary_list>div {
    width: 45%;
    font-size: 22px;
}

.deduct_money_employee_summary_list>div:nth-child(2) {
    width: 55%;
}

.detail_deduct_money_employee_summary_list>div {
    width: 45%;
    font-size: 18px;
}

.detail_deduct_money_employee_summary_list>div:nth-child(3) {
    width: 10%;
}
</style>
